import img1 from '../assets/images/img1.png';
import img2 from '../assets/images/img2.png';
import img3 from '../assets/images/img3.png';
import img4 from '../assets/images/img4.png';
import img5 from '../assets/images/img5.png';
import circle1 from '../assets/images/circle1.svg';
import circle2 from '../assets/images/circle2.svg';
import banner from '../assets/images/banner.png';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link, useNavigate } from 'react-router-dom';
import { allPost } from '../slices/posts';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allAd } from '../slices/advertisements';

const Home = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { allposts, Status } = useSelector((state) => state.posts);
    const { allads } = useSelector((state) => state.advertisement);

    const { t, i18n } = useTranslation();

    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';

    let tmpVar = {
        page: 1,
        sort: defaultSort,
        activeLang: currentLang,
        listType: 'home'
    };
    useEffect(() => {
        dispatch(allPost(tmpVar));
        dispatch(allAd(tmpVar));
    }, []);
    
    const viewPost = (id) => {
        navigate('/post/view/' + id);
    }
    const viewAdvrt = (id) => {
        navigate('/advertisement/view/' + id);
    }

    const options = {
        items: 1,
        nav: true,
        navText: ["<span class='fa fa-angle-left'></span>", "<span class='fa fa-angle-right'></span>"],
        rewind: true,
        autoplay: true,
        slideBy: 1,
        dots: false,
        dotsEach: true,
        dotData: true,
        // responsive:{
        //     0:{
        //         items:1
        //     },
        //     600:{
        //         items:1
        //     },
        //     1000:{
        //         items:1
        //     }
        // }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6 home-content">
                    <div className="">
                        <h4 className="font-color heading-1"> {t('home_title')}</h4>
                        <h1><span className="heading-2">{t('welcome1')} </span><span className="heading-3">{t('welcome2')}</span></h1>
                        <p className="heading-4">{t('home_text')}</p>
                        <br />
                        <Link className='success-btn' to="/about">{t('about')}</Link>
                    </div>
                </div>
                <div className="col-md-6 p-5 mt-5 homepage-right">
                    {/* <br /> */}
                    {/* <div className="d-flex home-img-section">
                        <div>
                            <img src={img1} className='homeimg-1' />
                        </div>
                        <div style={{position:'relative'}}>
                            <img src={circle1} className='home-circle-1' />
                            <img src={img3} className='homeimg-2 mb-3' />
                            <img src={img2} className='homeimg-3' />
                            <img src={circle2} className='home-circle-2' />
                        </div>
                    </div> */}
                    <img src={banner} style={{ width: '100%' }} />
                </div>
            </div>

            <div className='row pb-5'>
                <div className='col-md-12'>
                    <div className='section-title'>
                        <h1><span className='font-color-1'>{t('our')}</span> <span className='font-color-2'>{t('post')}</span></h1>
                        <p>{t('approved_post')}</p>
                    </div>
                </div>
                <div className='mt-2-new'>
                    {
                        allposts &&
                        <OwlCarousel className="owl-theme" {...options} >
                            {
                                allposts?.res.map((item, index) => {
                                    return (
                                        <div className='card post-card home-card' key={`post_${item.id}`} onClick={()=>viewPost(item.id)}>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-6 mb-2'>
                                                        <img src={item.image_path} className='sliderimg' />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className='ps-3'>
                                                            <h3 className='post-title'>{item.title}</h3>
                                                            <p className='post-content mt-1-5'>
                                                                {item.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </OwlCarousel>
                    }
                </div>
            </div>

            <div className='row mt-5'>
                <div className='col-md-12'>
                    <div className='section-title'>
                        <h1><span className='font-color-1'>{t('business')} </span> <span className='font-color-2'>{t('advertisements')}</span></h1>
                        <p>{t('approved_advrt')}</p>
                    </div>
                </div>
                <div className='mt-3'>
                    {
                        allads &&
                        <OwlCarousel className="owl-theme" {...options} >
                            {
                                allads?.res.map((item, index) => {
                                    return (
                                        <div className='card post-card home-card' key={`ads_${item.id}`} onClick={()=>viewAdvrt(item.id)}>
                                            <div className='card-body'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <h3 className='post-title'>{item.title}</h3>
                                                        <p className='post-content mt-1-5'>
                                                            {item.description}
                                                        </p>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <img src={item.image_path} className='sliderimg' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </OwlCarousel>
                    }

                </div>
            </div>

        </div>
    );
}
export default Home;